/**
 * NotificationBell Component
 * Displays notification icon with unread count badge
 */

import React, { useState } from 'react';
import { useNotifications } from '../../context/NotificationContext';
import NotificationPanel from './NotificationPanel';
import './NotificationBell.css';

const NotificationBell = () => {
  const { unreadCount, isConnected } = useNotifications();
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const togglePanel = () => {
    setIsPanelOpen(prev => !prev);
  };

  return (
    <div className="notification-bell-container">
      <button 
        className={`notification-bell-button ${!isConnected ? 'disconnected' : ''}`}
        onClick={togglePanel}
        aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
        title={isConnected ? 'Notifications' : 'Notifications (Disconnected)'}
      >
        <svg 
          className="notification-bell-icon" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        
        {unreadCount > 0 && (
          <span className="notification-badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}

        {!isConnected && (
          <span className="notification-status-indicator" title="Disconnected" />
        )}
      </button>

      {isPanelOpen && (
        <NotificationPanel onClose={() => setIsPanelOpen(false)} />
      )}
    </div>
  );
};

export default NotificationBell;
